import { useState } from 'react'
import Link from 'next/link'
import Btn from 'components/btn/btn'
import Heading from 'components/heading/heading'
import Form from 'components/form/form'
import Icon from 'components/icon/icon'
import rootStyles from './../root.module.scss'
import styles from './review-form.module.scss'
import { cn } from 'utils/helpers'
import useApi from 'utils/api'
import Radio from 'components/input/radio/radio'

const list = ['Sau', 'Šeimos nariui', 'Draugui', 'Kolegai', 'Klientui', 'Vadovui', 'Kita']

const options = list.map(name => {
    return { name, value: name }
})

export default function ReviewForm({ hideModal, onSuccesss, code }) {
    const [stars, setStars] = useState(0)
    const [hover, setHover] = useState(0)
    const api = useApi()

    const [reason, setReason] = useState()

    const handleChange = e => {
        setReason(e.target.value)
    }

    const submitHandler = async data => {
        const response = await api.postWithToast('review', { ...data, stars, reason, code })

        if (response.status === 200) {
            if (onSuccesss) onSuccesss()
            if (hideModal) hideModal()
        }
    }

    const handleMouseEnter = no => {
        setHover(no)
    }

    const handleMouseLeave = () => {
        setHover(0)
    }

    const handleClick = no => {
        setStars(no)
    }

    const fields = code
        ? [
              {
                  name: 'occasion',
                  type: 'input',
                  minLength: 3,
                  label: 'Kokia proga pirkote prekes?',
                  value: ''
              },
              {
                  name: 'content',
                  type: 'textarea',
                  label: 'Atsiliepimas',
                  minLength: 3,
                  value: '',
                  required: true
              }
          ]
        : [
              {
                  name: 'content',
                  type: 'textarea',
                  label: 'Atsiliepimas',
                  value: '',
                  required: true
              }
          ]

    const props = {
        onSubmit: submitHandler,
        submitText: 'Pateikti atsiliepimą',
        align: 'center',
        extraButtons: (
            <Btn style="light" onClick={hideModal}>
                Uždaryti
            </Btn>
        ),
        extraElements: (
            <>
                <Stars
                    onClick={handleClick}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    number={hover ? hover : stars}
                    value={stars ? stars : ''}
                />
                {code && (
                    <>
                        <div className={styles.reasonsLabel}>Kam pirkote prekes?</div>
                        <div
                            className={cn(
                                styles.reasons,
                                'mb30 reasonsForm',
                                reason && reason != 'Sau' && styles.otherPerson
                            )}
                        >
                            <Radio name="reason" value={reason} onChange={handleChange} options={options} />
                        </div>
                    </>
                )}
            </>
        ),
        fields
    }

    return (
        <div className={rootStyles.content}>
            <Heading tag="h1" size="36" className="mb24">
                Palikite atsiliepimą
            </Heading>
            <Heading tag="h1" size="18" className="mb24">
                ir gaukite 15% nuolaidos kodą. *
            </Heading>
            <Form {...props} />
            {code && (
                <>
                    <br />
                    <br />
                    <small className="faded">
                        * Nuolaida galioja tik tam tikrų parduotuvių prekėms. Peržiūrėkite dalyvaujančias parduotuves{' '}
                        <Link href="/parduotuviu-nuolaidos">
                            <a target="_blank">ČIA</a>
                        </Link>
                        . Nuolaidos kodo galiojimo laikas - 7 dienos.
                    </small>
                </>
            )}
        </div>
    )
}

function Stars({ number, value, onClick, onMouseEnter, onMouseLeave }) {
    const range = [1, 2, 3, 4, 5]

    return (
        <div className={cn(styles.stars, 'mb36')} onMouseLeave={onMouseLeave}>
            {range.map(no => (
                <Icon
                    key={no}
                    icon="star"
                    className={cn(styles.icon, number >= no && styles.active)}
                    onClick={() => onClick(no)}
                    onMouseEnter={() => onMouseEnter(no)}
                />
            ))}
            <input required value={value} type="number" onChange={() => {}} />
        </div>
    )
}
